import './contact.css';

export function ContactPage() {


    return (
        <div className="container-fluid bg bg-black d-flex justify-content-center align-items-center " style={{ height: "100vh", width: "100%" }}>
            <div className="contact-page z-1 row">
                <div className='col con-box1'>
                    <div className="mainBox">
                        <div className="mBox1" data-aos="fade-right">
                            <h1>Contact</h1>
                        </div>
                        <div className="mBox2" data-aos="fade-left">
                            <h2>Get in touch with me</h2>
                        </div>
                        <div className="mBox3" data-aos="flip-right">
                            <p>I am currently in my final year of MCA at Einstein Academy of Technology and Management, Bhubaneswar. I am actively seeking a Full Stack Developer full-time position to apply my skills and contribute to impactful projects. I have been trained in Full Stack Java Development at NareshIT, Hyderabad. Feel free to reach out to me via email if you have any questions — I’ll be happy to respond promptly.</p>
                        </div>
                        <div className="mBox4">
                            <a href="mailto:pravanjanamanta@gmail.com">Email Me</a>
                        </div>
                    </div>
                </div>
               
            </div>
        </div>
    )
}